import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorPage from 'next/error';
import isMobileOrTablet from '../utils/isMobileOrTablet';
import Foldable from '../utils/Foldable';

/* eslint react/display-name: 0 */

const TrafficPage = ({ errorCode }) => {
  useEffect(() => {
    let scrpt;
    function loadScript() {
      scrpt = document.createElement('script');
      scrpt.id = 'tomtom';
      scrpt.async = false;
      scrpt.src =
        'https://api.tomtom.com/maps-sdk-for-web/cdn/5.x/5.69.1/maps/maps-web.min.js';
      document.body.appendChild(scrpt);
    }
    loadScript();
    scrpt.addEventListener('load', function () {
      window.Foldable = window.Foldable || Foldable;
      const tt = window.tt;
      var flowConfig = {
        key: 'iYG5AvhGoflGcVxukf0jdUOtWXb0pgZl',
        style: 'tomtom://vector/1/relative0',
        refresh: 30000,
      };
      var incidentConfig = {
        key: 'iYG5AvhGoflGcVxukf0jdUOtWXb0pgZl',
        incidentDetails: {
          style: 's0',
        },
        incidentTiles: {
          style: 'tomtom://vector/1/s0',
        },
        refresh: 30000,
      };
      var map = tt.map({
        key: 'iYG5AvhGoflGcVxukf0jdUOtWXb0pgZl',
        container: 'map',
        style: 'tomtom://vector/1/basic-main',
        center: [-93.258133, 44.986656],
        zoom: 10,
        dragPan: !isMobileOrTablet(),
      });

      //initial state
      var flowTier = new tt.TrafficFlowTilesTier(flowConfig);
      var incidentsTier = new tt.TrafficIncidentTier(incidentConfig);
      map.addTier(flowTier);
      map.addTier(incidentsTier);
      map.addControl(new tt.FullscreenControl());
      map.addControl(new tt.NavigationControl());

      new Foldable('.js-foldable', 'top-right');
    });
    return () => {
      const tomtomScript = document.getElementById('tomtom');
      document.body.removeChild(tomtomScript);
    };
  }, []);

  if (errorCode) return <ErrorPage statusCode={errorCode} />;

  return (
    <div>
      <h1 className="hdg hdg-1">Traffic</h1>
      <div id="map" className="map" style={{ width: '100%', height: '500px' }}>
        <div
          className="tt-overlay-panel -left-top -medium js-foldable"
          style={{ width: '200px' }}
        ></div>
      </div>
    </div>
  );
};

TrafficPage.getInitialProps = async ({ res }) => {
  if (res) {
    res.setHeader('Cache-Control', 'public, max-age=300');
    res.setHeader('X-Frame-Options', 'DENY');
  }

  return <TrafficPage />;
};

TrafficPage.propTypes = {
  errorCode: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

export default TrafficPage;
